module.exports = __webpack_public_path__ + "images/illustrations/illustration-rise-cloud-2-5eedafacad3bc499f2ef6e32bd41be7f.webp";